<template>
	<ul class="nav justify-content-center pt-4 pb-5 customer-nav">
		<li class="nav-item">
			<router-link class="nav-link" :to="{ name: 'dashboard' }">
				<div class="nav-img">
					<img :src="home" class="img-fluid" alt="" />
				</div>
				Dashboard
			</router-link>
		</li>
		<li class="nav-item">
			<router-link class="nav-link" :to="{ name: 'portfolio.trade', params: { portfolio: descretional_portfolio } }">
				<div class="nav-img">
					<img :src="trading" class="img-fluid" alt="" />
				</div>
				TradeLive
			</router-link>
		</li>
		<li class="nav-item" v-if="isApprover">
			<router-link class="nav-link" :to="{ name: 'approvals.manage' }">
				<div class="nav-img">
					<img :src="approvals" class="img-fluid" alt="" />
				</div>
				Approvals
			</router-link>
		</li>
		<li class="nav-item">
			<router-link class="nav-link" :to="{ name: 'documents' }">
				<div class="nav-img">
					<img :src="document" class="img-fluid" alt="" />
				</div>
				Documents
			</router-link>
		</li>
		<li class="nav-item">
			<router-link class="nav-link" :to="{ path: '/app/messages', activeClass: 'active', exact: true }">
				<div class="nav-img">
					<img :src="chat" class="img-fluid" alt="chat" />
				</div>
				Messages
			</router-link>
		</li>
		<li class="nav-item">
			<router-link class="nav-link" :to="{ name: 'fees' }" exact>
				<div class="nav-img">
					<img :src="fees" class="img-fluid" alt="fees" />
				</div>
				Fees
			</router-link>
		</li>
	</ul>
</template>

<style scoped>
.customer-nav .nav-item {
	margin: 0px 20px;
}

.customer-nav .nav-item .nav-link {
	text-align: center;
}

.customer-nav .nav-img {
	width: 40px;
	margin: auto;
	margin-bottom: 10px;
}

@media (max-width: 425px) {
	.nav-link {
		display: block;
		padding: 0.5rem 0.8rem;
	}

	.customer-nav .nav-item {
		margin: 0px 3px;
	}

	.customer-nav .nav-img {
		width: 30px;
		margin-bottom: 10px;
	}
}
</style>

<script>
import home from '../../../../../../img/home.svg';
import approvals from '../../../../../../img/approvals.svg';
import document from '../../../../../../img/document.svg';
import chat from '../../../../../../img/chat.svg';
import trading from '../../../../../../img/trading.svg';
import fees from '../../../../../../img/money.svg';
import ipo from '../../../../../../img/coins.svg';
import { mapGetters } from 'vuex';

export default {
	mounted() {
		this.getApprovalPolicy();
		this.getTradePortfolioId();
	},
	data() {
		return {
			canApprove: false,
			home,
			approvals,
			document,
			chat,
			trading,
			fees,
			ipo,
			descretional_portfolio: 0,
			liquidity_portfolio: 0,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			company: 'company'
		}),
		isApprover() {
			return this.user.client.designation === 'approver' && this.canApprove;
		},
	},
	methods: {
		getApprovalPolicy() {
			axios
				.get('/api/companies/policies', {
					params: {
						type: 'APPROVAL_POLICY',
						external_client_id: this.company.external_client_id,
					},
				})
				.then(({ data: { data: { policy }}}) => {
					if (_.isEmpty(policy)) {
						this.canApprove = true;
					}else{
						this.canApprove = policy[0].meta_data.approvers.includes(this.user.id);
					}
				})
				.catch(({ response }) => console.log(response));
		},
		getTradePortfolioId() {
			axios
				.get(`/api/companies/${this.company.external_client_id}/portfolios`, {
					params: {
						noAllocation: true,
					},
				})
				.then(
					({
						data: {
							data: { portfolio },
						},
					}) => {
						portfolio.map((portfolioItem) => {
							if ((portfolioItem.portfolio_type_id === 1)) {
								this.descretional_portfolio = portfolioItem.external_portfolio_id;
							}

							if ((portfolioItem.portfolio_type_id === 2)) {
								this.liquidity_portfolio = portfolioItem.external_portfolio_id;
							}
						});
					}
				);
		},
	},
};
</script>